import React from "react";

function EmbedFH() {
  return (
    <section className='iframe iframe--fh'>
        <iframe title="Forever High Full Length Album" width="100%" height="450" scrolling="no" frameBorder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1474707343%3Fsecret_token%3Ds-e7Oey0y7gJz&color=%23b81a0a&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe>
        
        <div>
            <a href="https://soundcloud.com/crimsondevilsatx" title="Crimson Devils" rel="noreferrer" target="_blank">Crimson Devils</a> · <a href="https://soundcloud.com/crimsondevilsatx/sets/forever-high" title="Forever High" rel="noreferrer" target="_blank">Forever High</a>
        </div>
    </section>
  )
}

export default EmbedFH